import React, { useContext } from 'react'
import PropTypes from 'prop-types'

// component stack && helpers
import { Menu, MenuItem } from 'components/molecules'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import * as Styled from './MobileMenu.styles'
import { useSelector } from 'react-redux'
import { entryPointId } from 'settings/app/constants'
// import { getServiceMenuHeight } from 'settings/app/uiHelpers'

const MobileMenu = (props) => {
  const {
    toggleMapFullscreen = () => {},
    setIsFilterFullscreen = () => {},
    isFilterFullscreen = false,
    comparable = false,
    bookmarkCount = 0,
    onBookmarkClick = () => {},
    onCompareClick = () => {},
  } = props
  const textContext = useContext(TextContext)
  const entryPoint = useSelector((state) => state.application.entryPoint)
  // const initialScrollPosition = React.useRef(0)
  // const scrollYRef = React.useRef({ start: 0, current: 0 })
  // const [lift, setLift] = React.useState(false)

  // Change the position of the menu button
  // based on the scroll distance,
  // if you scroll down 300px then
  // move the menu button down
  // const handleScroll = () => {
  //   const { current: scrollY } = scrollYRef
  //   const windowScrollY = window.scrollY
  //   if (windowScrollY > scrollY.start) {
  //     const difference = scrollY.current - scrollY.start
  //     if (windowScrollY > scrollY.current) {
  //       scrollY.current = windowScrollY
  //     } else {
  //       scrollY.start = windowScrollY
  //     }
  //
  //     if (difference >= 300 && getServiceMenuHeight() === 0) {
  //       // debugger
  //       setLift(false)
  //     }
  //   } else {
  //     // Only move the menu button if the
  //     // site is not rendered with scroll
  //     // position bigger than 0
  //     if (initialScrollPosition.current > 0) {
  //       initialScrollPosition.current = 0
  //     } else {
  //       setLift(true)
  //     }
  //     scrollY.start = windowScrollY
  //     scrollY.current = windowScrollY
  //   }
  // }
  //
  // React.useEffect(() => {
  //   if (getServiceMenuHeight() > 0) {
  //     setLift(true)
  //   }
  // }, [])
  //
  // React.useLayoutEffect(() => {
  //   initialScrollPosition.current = window.scrollY
  //   window.addEventListener('scroll', handleScroll, false)
  //
  //   return () => window.removeEventListener('scroll', handleScroll)
  // }, [])

  return (
    <Styled.MobileMenu>
      {/* <Menu className={ `floating-menu ${ lift ? 'lifted-up' : '' }` }> */}
      <Menu className='floating-menu'>
        {comparable && (
          <MenuItem
            icon='icon-f-compare'
            label={ `${ textContext['mobileMenu.menuItem.label.compare'] }` }
            onClick={ onCompareClick }
          />
        )}
        {bookmarkCount !== 0 && (
          <MenuItem
            icon='icon-f-bookmarks'
            label={ `${ textContext['mobileMenu.menuItem.label.bookmarks'] } (${ bookmarkCount })` }
            onClick={ onBookmarkClick }
          />
        )}

        {entryPointId.MIDWIVES !== entryPoint && (
          <MenuItem
            icon='icon-f-overview-map'
            label={ textContext['mobileMenu.menuItem.label.map'] }
            onClick={ () => toggleMapFullscreen(true) }
          />
        )}
        <MenuItem
          data-cy='mobile-menu-filter'
          icon='icon-f-funnel'
          label={ textContext['mobileMenu.menuItem.label.filterAndSorts'] }
          onClick={ () => setIsFilterFullscreen(!isFilterFullscreen) }
        />
      </Menu>
    </Styled.MobileMenu>
  )
}

MobileMenu.propTypes = {
  toggleMapFullscreen: PropTypes.func,
  setIsFilterFullscreen: PropTypes.func,
  isFilterFullscreen: PropTypes.bool,
  comparable: PropTypes.bool,
  bookmarkCount: PropTypes.number,
  onBookmarkClick: PropTypes.func,
  onCompareClick: PropTypes.func,
}

export default MobileMenu
